import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { UPDATE_NAV_ITEM } from 'store/modules/competition-nav/actions';
import { SvgIcon } from '../../SvgIcon';

export const ResponsiveSeasonNavItem = ({ seasons }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    if (!seasons.find(({ id }) => id === Number(nav.season.id)) && seasons) {
        return '';
    }

    return (
        <div className="competition-nav__season-select">
            <SvgIcon
                icon="season-trophy"
                className="competition-nav__season-select-icon"
            />

            <SvgIcon
                className="competition-nav__season-select-chevron"
                icon="chevron-down"
            />

            <Select
                items={seasons}
                itemToString={(season) => season.name}
                selectedItemToString={(item) => item?.name.split(' ')[0]}
                initialSelectedItem={
                    seasons && nav.season.id
                        ? seasons.find(({ id }) => id === Number(nav.season.id))
                        : ''
                }
                activeItem={
                    seasons && nav.season.id
                        ? seasons.find(({ id }) => id === Number(nav.season.id))
                        : ''
                }
                isReadyToRender={() => seasons?.length && Number(nav.season.id)}
                label={getTranslation('label.stats.season')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        UPDATE_NAV_ITEM.request({
                            navItem: 'season',
                            value: {
                                id: selectedItem.id,
                                providerId: selectedItem.providerId
                            }
                        })
                    );
                }}
                hideLabel
            />
        </div>
    );
};

ResponsiveSeasonNavItem.propTypes = {
    seasons: PropTypes.array,
    hideLabel: PropTypes.bool
};
